'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _SpisovaSluzbaApi = require('./../api/gen/spisovaSluzba/SpisovaSluzbaApi');

var _SpisovaSluzbaApi2 = _interopRequireDefault(_SpisovaSluzbaApi);

var _StateSuggestField = require('./StateSuggestField');

var _StateSuggestField2 = _interopRequireDefault(_StateSuggestField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Základní formátování názvu typu dokumentu.
 *
 * @param typDokument typ dokumentu
 */
function getNazev(typDokument) {
    var result = typDokument.nazev;
    if (typDokument.kod) {
        result = typDokument.kod + " - " + typDokument.nazev;
    }
    return result;
}

/**
 * Field pro hledání typu dokumentů spisové služby.
 */

var SpsTypDokumentField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(SpsTypDokumentField, _AbstractReactCompone);

    function SpsTypDokumentField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SpsTypDokumentField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SpsTypDokumentField.__proto__ || (0, _getPrototypeOf2.default)(SpsTypDokumentField)).call.apply(_ref, [this].concat(args))), _this), _this.getData = function () {
            return _SpisovaSluzbaApi2.default.findTypyDokumentu().then(function (rows) {
                return rows.map(function (r) {
                    return (0, _extends3.default)({}, r, { _name: getNazev(r) });
                });
            }).then(function (rows) {
                rows.sort(function (a, b) {
                    return a._name.localeCompare(b._name);
                });
                return rows;
            });
        }, _this.handleOnChange = function (value) {
            var onChange = _this.props.onChange;

            if (value) {
                var _name = value._name,
                    rest = (0, _objectWithoutProperties3.default)(value, ['_name']);

                onChange(rest);
            } else {
                onChange(null);
            }
        }, _this.handleOnBlur = function (value) {
            var onBlur = _this.props.onBlur;

            if (value) {
                var _name = value._name,
                    rest = (0, _objectWithoutProperties3.default)(value, ['_name']);

                onBlur(rest);
            } else {
                onBlur(null);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SpsTypDokumentField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                onChange = _props.onChange,
                onBlur = _props.onBlur,
                other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onBlur']);


            return _react2.default.createElement(_StateSuggestField2.default, (0, _extends3.default)({
                getItemName: function getItemName(item) {
                    return item ? item._name || getNazev(item) : "";
                },
                apiCall: this.getData
            }, other, {
                onChange: this.handleOnChange,
                onBlur: this.handleOnBlur
            }));
        }
    }]);
    return SpsTypDokumentField;
}(_AbstractReactComponent2.default);

exports.default = SpsTypDokumentField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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